import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { ProgramProgressOverviewQueryKey } from 'components/Dashboards/Project/Components/VersionCompare/queries/tableDataQuery';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { useIsFetching } from 'react-query';
import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ProgressMeasurementFilter } from 'components/common/GlobalFilterComponent/components/progressMeasurementFilter/progressMeasurementFilter';
import { ResourceTypeFilter } from 'components/common/GlobalFilterComponent/components/resourceTypeFilter/resourceTypeFilter';
import { ResourceFilter } from 'components/common/GlobalFilterComponent/components/ResourceFilter/resourceFilter';
import { useProgressMeasurement } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/progressMeasurementPreference/useProgressMeasurementPreference';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import ProgressSummary from 'components/widgets/ProgressSummary/ProgressSummary';
import RenderCriticalAnalysisIntensity from 'components/widgets/SCurve/Scurve';
import DelayedActivities from 'components/widgets/DelayedActivities/DelayedActivities';
import HighLevelProgram from 'components/widgets/HighLevelProgram/HighLevelProgram';
import MilestonesDistribution from 'components/widgets/MilestonesDistribution/MilestonesDistribution';

export const ProgressPage = () => {
    useFullStoryPageView({ pageName: projectConfig.progressOverview.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return ProgramProgressOverviewQueryKey.includes(key);
        },
    });
    useScrollTo(isFetching);

    const { value: progressMeasurementValue } = useProgressMeasurement();
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={projectConfig.progressOverview.title} />
                        <VersionCompareSelectorWrapper isBaselineSelected={true} allowSingleVersion={true} />
                    </VersionSection>
                    <ShareInsightButton title={projectConfig.progressOverview.title} link={window.location.href} />
                    <GlobalFilterButton />
                </VersionWrapper>

                {progressMeasurementValue !== undefined && (
                    <GlobalFilterComponent
                        defaultValues={{
                            progressMeasurement: progressMeasurementValue,
                            milestoneFragnet: null,
                            tags: [],
                            activityCodes: [],
                            wbs: null,
                            resourceType: null,
                            resource: null,
                        }}
                    >
                        <ProgressMeasurementFilter name={'progressMeasurement'} />
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                        <ResourceTypeFilter name={'resourceType'} />
                        <ResourceFilter name={'resource'} />
                    </GlobalFilterComponent>
                )}
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <ProgressSummary />
                    <RenderCriticalAnalysisIntensity />
                    <DelayedActivities />
                    <HighLevelProgram />
                    <MilestonesDistribution />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={ProgramProgressOverviewQueryKey} />
        </PageContainer>
    );
};
